import { theme } from '@chakra-ui/react';

export default {
  baseStyle: {
    ...theme.components.Modal.baseStyle,
    overlay: {
      bgColor: 'rgba(0,0,0,0.3)',
    },
  },
};
